import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { login as apiLogin, logout as apiLogout } from '../../services/api';

const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, check if a token exists in localStorage
  useEffect(() => {
    const token = localStorage.getItem('ta_token');
    if (token) {
      try {
        // Decode JWT payload (no verification — server verifies)
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setAdmin({ id: payload.sub, email: payload.email, name: payload.name, phone: payload.phone });
        } else {
          localStorage.removeItem('ta_token');
        }
      } catch {
        localStorage.removeItem('ta_token');
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const result = await apiLogin(email, password);
    setAdmin(result.data.admin);
    return result;
  }, []);

  const logout = useCallback(() => {
    apiLogout();
    setAdmin(null);
  }, []);

  return (
    <AuthContext.Provider value={{ admin, setAdmin, loading, login, logout, isAuthenticated: !!admin }}>
      {children}
    </AuthContext.Provider>
  );
}
